var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"analytics-select-filter"},[_c('ds-select-field',{attrs:{"bind-value-only":"","options":_vm.filter.valueOptions},model:{value:(_vm.filter.value),callback:function ($$v) {_vm.$set(_vm.filter, "value", $$v)},expression:"filter.value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }